import { useState } from "react";
import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { Sheet } from "@/components/ax/Sheet";
import { useI18n } from "@/i18n";

export const HighlightSheet = ({ text, onClose, onSave }) => {
  const { t } = useI18n();
  const [color, setColor] = useState("teal");
  const [remark, setRemark] = useState("");
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  const save = async () => {
    setBusy(true);
    setFailed(false);
    const ok = await onSave({ text, color, remark });
    setBusy(false);
    if (!ok) setFailed(true);
  };

  return (
    <Sheet open onOpenChange={(o) => !o && onClose()} title={t("highlight.title")} testId="highlight-sheet">
      <blockquote
        data-testid="highlight-quote"
        style={{ borderLeftColor: color === "gold" ? "#C9A227" : "#0D9488" }}
        className="m-0 border-0 border-l-[3px] pl-3 text-base leading-6 text-ax-text [overflow-wrap:anywhere]"
      >
        {text}
      </blockquote>
      <fieldset className="m-0 mt-4 min-w-0 border-0 p-0">
        <legend className="p-0 text-sm font-medium leading-5 text-ax-text">{t("highlight.color")}</legend>
        <div className="mt-2 grid grid-cols-2 gap-2">
          {["teal", "gold"].map((c) => (
            <label key={c} className="relative block">
              <input type="radio" name="hl-color" checked={color === c} onChange={() => setColor(c)} data-testid={`highlight-color-${c}`} className="peer sr-only" />
              <span
                className={`flex min-h-[48px] cursor-pointer items-center justify-center gap-2 rounded-[8px] border px-2 text-sm font-medium peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-ax-focus-ring ${
                  color === c ? "border-ax-accent text-ax-text" : "border-ax-border text-ax-text-2"
                }`}
              >
                <span aria-hidden="true" className="block h-3 w-3 rounded-full" style={{ background: c === "gold" ? "#C9A227" : "#0D9488" }} />
                {t(`highlight.${c}`)}
              </span>
            </label>
          ))}
        </div>
      </fieldset>
      <Field
        multiline
        label={t("highlight.remark")}
        hint={t("highlight.remarkHint")}
        maxLength={280}
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
        testId="highlight-remark-input"
        className="mt-4 [&_textarea]:min-h-[80px]"
      />
      {failed && (
        <p role="alert" data-testid="highlight-error" className="m-0 mt-3 text-sm leading-5 text-ax-error">
          {t("err.saveHighlight")}
        </p>
      )}
      <Button variant="primary" busy={busy} disabled={busy} onClick={save} data-testid="highlight-save-button" className="mt-6 w-full">
        {t("highlight.save")}
      </Button>
      <Button onClick={onClose} data-testid="highlight-close-button" className="mt-2 w-full">
        {t("items.close")}
      </Button>
    </Sheet>
  );
};
